var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.numPages),function(i){return _c('v-card',{key:i,staticClass:"mb-3"},[_c('v-card-text',[_c('pdf',{attrs:{"src":_vm.pdfsrc,"page":i}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }